import {
  LIST_INDUSTRI_REQUEST,
  LIST_INDUSTRI_SUCCESS,
  LIST_INDUSTRI_FAIL,
  LIST_INDUSTRI_SUMMARY_REQUEST,
  LIST_INDUSTRI_SUMMARY_SUCCESS,
  LIST_INDUSTRI_SUMMARY_FAIL,
  CREATE_INDUSTRI_REQUEST,
  CREATE_INDUSTRI_SUCCESS,
  CREATE_INDUSTRI_FAIL,
  DETAIL_INDUSTRI_REQUEST,
  DETAIL_INDUSTRI_SUCCESS,
  DETAIL_INDUSTRI_FAIL,
  UPDATE_INDUSTRI_REQUEST,
  UPDATE_INDUSTRI_SUCCESS,
  UPDATE_INDUSTRI_FAIL,
  DELETE_INDUSTRI_REQUEST,
  DELETE_INDUSTRI_SUCCESS,
  DELETE_INDUSTRI_FAIL,
  RESET_INDUSTRI
} from '../../constants/industries'

const initialState = {
  loading: false,
  industries: [],
  industriesSummary: [],
  industri: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const listIndustriReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_INDUSTRI_REQUEST:
      return { ...state, loading: true }
    case LIST_INDUSTRI_SUCCESS:
      return {
        ...state,
        loading: false,
        industries: action.payload,
        pageable: action.pageable
      }
    case LIST_INDUSTRI_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        industries: action?.dummy
      }
    case LIST_INDUSTRI_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_INDUSTRI_SUMMARY_SUCCESS:
      return { ...state, loading: false, industriesSummary: action.payload }
    case LIST_INDUSTRI_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case CREATE_INDUSTRI_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_INDUSTRI_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_INDUSTRI_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_INDUSTRI_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_INDUSTRI_SUCCESS:
      return { ...state, loadingDetail: false }
    case DETAIL_INDUSTRI_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_INDUSTRI_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_INDUSTRI_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_INDUSTRI_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_INDUSTRI_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_INDUSTRI_SUCCESS:
      const industriIdDelete = action.payload
      const industriesDelete = [...state.industries]

      const indexDelete = industriesDelete.findIndex(
        (industri) => industri.id === industriIdDelete
      )
      industriesDelete.splice(indexDelete, 1)
      return { ...state, loadingDelete: false, industries: industriesDelete }
    case DELETE_INDUSTRI_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_INDUSTRI:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default listIndustriReducer
